import {
  centeredContainerStyle,
  errorBackgroundStyles,
  invalidSubtitleStyle,
  invalidTitleStyle,
} from './styles';
import { ButtonBase } from '../../../../../common/components/ButtonBase/ButtonBase';
import { TCryptoTransferTranslations } from '../../../../utils/getCryptoTransferTranslations';
import {
  FilledCircularArrows,
  FilledErrorX,
} from '../../../../../common/svgIcons';

export const ErrorLoadingList = ({
  error,
  onTryAgain,
  translations,
}: {
  error?: string;
  onTryAgain: () => void;
  translations: TCryptoTransferTranslations;
}) => {
  return (
    <div className={centeredContainerStyle}>
      <div className={errorBackgroundStyles}>
        <FilledErrorX size={24} />
      </div>
      <p className={invalidTitleStyle}>{translations.errorWalletList}</p>
      {error && <p className={invalidSubtitleStyle}>{error}</p>}

      <ButtonBase onClick={onTryAgain} size="small" visual="secondary">
        {translations.tryAgain}
        <FilledCircularArrows />
      </ButtonBase>
    </div>
  );
};
